export const getCandidatesByCandidatesBatch = /* GraphQL */ `
  query GetCandidatesByCandidatesBatch(
    $candidateBatchId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCandidateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getCandidatesByCandidatesBatch(
      candidateBatchId: $candidateBatchId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        totalScore
        totalScoreScaled
        firstName
        lastName
        email
        candidateBatchId
        conversationId
        createdAt
        updatedAt
        cvS3Key
        scoring {
          category
          score
          description
        }
        status
      }
      nextToken
    }
  }
`;

export const getCandidate = /* GraphQL */ `
  query GetCandidate($id: ID!) {
    getCandidate(id: $id) {
      id
      totalScore
      totalScoreScaled
      firstName
      lastName
      phoneNumber
      email
      candidateBatchId
      conversationId
      createdAt
      updatedAt
      status
      scoring {
        category
        weight
        score
        scoreScaled
        description
      }
      cvS3Key
      linkedInProfileId
      isMessagesGenerating
      isAllRequirementsMet
      requirements {
        content
        isMet
      }
      atsCandidateId
      atsApplicationId
    }
  }
`;

export const getCandidateWithCandidateBatch = /* GraphQL */ `
  query GetCandidate($id: ID!) {
    getCandidate(id: $id) {
      id
      totalScore
      totalScoreScaled
      analysisErrorCode
      firstName
      lastName
      phoneNumber
      email
      candidateBatchId
      isLocked
      candidateBatch {
        id
        cvS3Keys
        csvS3Key
        jobDescription
        status
        campaignId
        candidatesCount
        candidatesRequirementsMetCount
        candidatesRequirementsNotMetCount
        candidatesToProcessCount
        organizationId
        userId
        createdAt
        atsJobId
        atsJobPostingId
        atsJobReference
        isRecalculatingScores
        candidateBatchGroupId
        isInitial
        candidateBatchReanalysisReferenceId
        isWorkflowManaged
        updatedAt
        # __typename
      }
      conversationId
      conversation {
        id
        calendarBookingId
      }
      createdAt
      updatedAt
      status
      scoring {
        category
        weight
        score
        scoreScaled
        description
      }
      cvS3Key
      cvParsedText
      linkedInProfileId
      isMessagesGenerating
      isAllRequirementsMet
      requirements {
        content
        isMet
      }
      atsCandidateId
      atsApplicationId
      atsQuestionnaireAnswers {
        answer
        atsQuestionId
        question
      }
    }
  }
`;

export const getCandidatesByCandidatesBatchAndScore = /* GraphQL */ `
  query GetCandidatesByCandidatesBatchAndScore(
    $candidateBatchId: ID!
    $totalScore: ModelFloatKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCandidateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getCandidatesByCandidatesBatchAndScore(
      candidateBatchId: $candidateBatchId
      totalScore: $totalScore
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        totalScore
        totalScoreScaled
        firstName
        lastName
        phoneNumber
        email
        candidateBatchId
        conversationId
        createdAt
        updatedAt
        cvS3Key
        linkedInProfileId
        scoring {
          category
          weight
          score
          scoreScaled
          description
        }
        isAllRequirementsMet
        requirements {
          content
          isMet
        }
        status
      }
      nextToken
    }
  }
`;

export const getProfileData = /* GraphQL */ `
  query GetProfileData($profileId: String!) {
    getProfileData(profileId: $profileId) {
      profileId
      data
      createdAt
      updatedAt
    }
  }
`;

export const generateJobRequirements = /* GraphQL */ `
  query GenerateJobRequirements($jobDescription: String!) {
    generateJobRequirements(jobDescription: $jobDescription) {
      requirements {
        content
        isMandatory
      }
    }
  }
`;

export const getCandidateBatchByOrganization = /* GraphQL */ `
  query GetCandidateBatchByOrganization(
    $organizationId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCandidateBatchFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getCandidateBatchByOrganization(
      organizationId: $organizationId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        jobDescriptionParsed {
          jobTitle
          employerName
          location
          contractType
          hours
          salary
          closingDate
          summaryOfRole
          responsibilities
          qualifications
          benefits
          diversityEqualityInclusion
        }
        status
        campaignId
        candidatesCount
        candidatesRequirementsMetCount
        candidatesRequirementsNotMetCount
        candidatesToProcessCount
        organizationId
        userId
        createdAt
        atsJobId
        atsJobReference
        isRecalculatingScores
        updatedAt
        user {
          id
          name
        }
        candidateBatchGroup {
          id
          name
        }
      }
      nextToken
    }
  }
`;

export const exportAnalysisData = /* GraphQL */ `
  query ExportAnalysisData($candidateBatchId: String!) {
    exportAnalysisData(candidateBatchId: $candidateBatchId) {
      url
    }
  }
`;

export const getCandidatesByCandidatesBatchAndScoreScaled = /* GraphQL */ `
  query GetCandidatesByCandidatesBatchAndScoreScaled(
    $candidateBatchId: ID!
    $totalScoreScaled: ModelFloatKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCandidateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getCandidatesByCandidatesBatchAndScoreScaled(
      candidateBatchId: $candidateBatchId
      totalScoreScaled: $totalScoreScaled
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        totalScore
        totalScoreScaled
        firstName
        lastName
        phoneNumber
        email
        candidateBatchId
        conversationId
        conversation {
          id
          campaignId
        }
        createdAt
        updatedAt
        cvS3Key
        linkedInProfileId
        scoring {
          category
          weight
          score
          scoreScaled
          description
        }
        isAllRequirementsMet
        requirements {
          content
          isMet
        }
        status
        atsCandidateId
        atsApplicationId
      }
      nextToken
    }
  }
`;

export const getCandidateNotesByCandidate = /* GraphQL */ `
  query GetCandidateNotesByCandidate(
    $candidateId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCandidateNoteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getCandidateNotesByCandidate(
      candidateId: $candidateId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        content
        candidateId
        organizationId
        userId
        user {
          id
          name
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const getAnalysisRequirementsByCandidateBatch = /* GraphQL */ `
  query GetAnalysisRequirementsByCandidateBatch(
    $candidateBatchId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAnalysisRequirementFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getAnalysisRequirementsByCandidateBatch(
      candidateBatchId: $candidateBatchId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        originalRequirementText
        generatedRequirementText
        isMandatory
        weight
        organizationId
        candidateBatchId
        createdAt
        updatedAt
        parentAnalysisRequirementId
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const getCandidateEmailCorrespondencesByCandidate = /* GraphQL */ `
  query GetCandidateEmailCorrespondencesByCandidate(
    $candidateId: ID!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCandidateEmailCorrespondenceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getCandidateEmailCorrespondencesByCandidate(
      candidateId: $candidateId
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        organizationId
        candidateId
        atsCandidateId
        subject
        body
        recipientEmailAddress
        senderEmailAddress
        status
        scheduleId
        scheduledAt
        sentAt
        sesMessageId
        createdAt
        updatedAt
        type
      }
      nextToken
    }
  }
`;

export const getCandidateBatchGroupByOrganization = /* GraphQL */ `
  query GetCandidateBatchGroupByOrganization(
    $organizationId: ID!
    $updatedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCandidateBatchGroupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getCandidateBatchGroupByOrganization(
      organizationId: $organizationId
      updatedAt: $updatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        organizationId
        user {
          id
          name
        }
        name
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const getCandidateBatchesByCandidateBatchGroup = /* GraphQL */ `
  query GetCandidateBatchesByCandidateBatchGroup(
    $candidateBatchGroupId: ID!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCandidateBatchFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getCandidateBatchesByCandidateBatchGroup(
      candidateBatchGroupId: $candidateBatchGroupId
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        cvS3Keys
        csvS3Key
        jobDescription
        status
        campaignId
        candidatesCount
        candidatesRequirementsMetCount
        candidatesRequirementsNotMetCount
        candidatesToProcessCount
        organizationId
        userId
        createdAt
        atsJobId
        isRecalculatingScores
        candidateBatchGroupId
        isInitial
        candidateBatchReanalysisReferenceId
        updatedAt
        atsJobReference
        user {
          id
          name
        }
        jobDescriptionParsed {
          jobTitle
          employerName
          location
          contractType
          hours
          salary
          closingDate
          summaryOfRole
          responsibilities
          qualifications
          benefits
          diversityEqualityInclusion
        }
        candidateBatchGroup {
          id
          name
        }
      }
      nextToken
    }
  }
`;

export const getCandidateBatchGroup = /* GraphQL */ `
  query GetCandidateBatchGroup($id: ID!) {
    getCandidateBatchGroup(id: $id) {
      id
      organizationId
      userId
      user {
        id
        email
      }
      name
      updatedAt
      createdAt
    }
  }
`;

export const getAnalysisRequirementsByCandidateBatchGroup = /* GraphQL */ `
  query GetAnalysisRequirementsByCandidateBatchGroup(
    $candidateBatchGroupId: ID!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAnalysisRequirementFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getAnalysisRequirementsByCandidateBatchGroup(
      candidateBatchGroupId: $candidateBatchGroupId
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        originalRequirementText
        generatedRequirementText
        isMandatory
        weight
        organizationId
        candidateBatchId
        candidateBatchGroupId
        isParent
        parentAnalysisRequirementId
        createdAt
        updatedAt
        __typename
      }
      nextToken
    }
  }
`;

export const searchCandidateBatches = /* GraphQL */ `
  query SearchCandidateBatches(
    $filter: SearchableCandidateBatchFilterInput
    $sort: [SearchableCandidateBatchSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableCandidateBatchAggregationInput]
  ) {
    searchCandidateBatches(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        cvS3Keys
        csvS3Key
        jobDescription
        status
        campaignId
        candidatesCount
        candidatesRequirementsMetCount
        candidatesRequirementsNotMetCount
        candidatesToProcessCount
        organizationId
        userId
        createdAt
        atsJobId
        title
        atsJobPostingId
        atsJobReference
        isRecalculatingScores
        candidateBatchGroupId
        isInitial
        candidateBatchReanalysisReferenceId
        user {
          id
          name
        }
        candidateBatchGroup {
          id
          name
        }
        jobDescriptionParsed {
          jobTitle
          location
          contractType
          hours
          salary
        }
        updatedAt
      }
      nextToken
      total
    }
  }
`;

export const searchCandidates = /* GraphQL */ `
  query SearchCandidates(
    $filter: SearchableCandidateFilterInput
    $sort: [SearchableCandidateSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableCandidateAggregationInput]
  ) {
    searchCandidates(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        firstName
        lastName
        totalScoreScaled
        status
        candidateBatchId
        createdAt
        isAllRequirementsMet
        candidateBatch {
          jobDescriptionParsed {
            jobTitle
          }
          candidateBatchGroupId
          candidateBatchGroup {
            name
          }
          atsJobReference
          status
        }
        atsApplicationSource
      }
      nextToken
      total
    }
  }
`;

export const exportAllAnalysisData = /* GraphQL */ `
  query ExportAllAnalysisData {
    exportAllAnalysisData {
      message
      __typename
    }
  }
`;
